import _objectSpread from "/usr/app/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import React from "react";
var __jsx = React.createElement;
import { useEffect, useState } from "react";
import CheckBox from "./CheckBox/CheckBox";
import stl from "./CheckBoxGroup.module.css";
import { CDN_LINK } from "@globalConfig";
import { useTranslation } from "@i18n";
var CheckBoxGroup = function CheckBoxGroup(_ref) {
  var options = _ref.options,
    onChange = _ref.onChange,
    name = _ref.name,
    searchable = _ref.searchable,
    isColor = _ref.isColor,
    hasSubGroups = _ref.hasSubGroups,
    isBoldGropuTitle = _ref.isBoldGropuTitle,
    isColorFilter = _ref.isColorFilter,
    carshape = _ref.carshape,
    fieldName = _ref.fieldName,
    selectedOptions = _ref.selectedOptions,
    filterType = _ref.filterType,
    handleCloseFilter = _ref.handleCloseFilter,
    tempSelectedOptions = _ref.tempSelectedOptions,
    openedFilter = _ref.openedFilter,
    filter = _ref.filter;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var _useState = useState(""),
    searchValue = _useState[0],
    setSearchValue = _useState[1];
  var filteredOptions = function filteredOptions() {
    if ((filter === null || filter === void 0 ? void 0 : filter.filterField) === "make_id") {
      return options === null || options === void 0 ? void 0 : options.filter(function (option) {
        return option.name.toLowerCase().includes(searchValue.toLowerCase());
      });
    }
    if ((filter === null || filter === void 0 ? void 0 : filter.filterField) === "model_id") {
      var _filteredOptions = [];
      options.forEach(function (option) {
        var subFilteredOptions = option.values.filter(function (subOption) {
          return subOption.name.toLowerCase().includes(searchValue.toLowerCase());
        });
        if (subFilteredOptions.length) _filteredOptions.push(_objectSpread(_objectSpread({}, option), {}, {
          values: subFilteredOptions
        }));
      });
      return _filteredOptions;
    }
  };
  useEffect(function () {
    if (!openedFilter) setSearchValue("");
  }, [openedFilter]);
  var renderer = function renderer() {
    if (searchable && (options === null || options === void 0 ? void 0 : options.length) > 0 && (filter === null || filter === void 0 ? void 0 : filter.filterField) === "make_id") {
      var _filteredOptions2;
      return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
        className: stl.textBoxContainer
      }, /*#__PURE__*/React.createElement("img", {
        src: CDN_LINK + "/assets/images/textsearch.svg",
        alt: "search"
      }), /*#__PURE__*/React.createElement("input", {
        id: "filter-checkbox-search-make",
        type: "text",
        placeholder: t("ابحث عن الماركة", {
          ns: "web_search"
        }),
        value: searchValue,
        onChange: function onChange(e) {
          return setSearchValue(e.target.value);
        }
      })), (_filteredOptions2 = filteredOptions()) === null || _filteredOptions2 === void 0 ? void 0 : _filteredOptions2.map(function (option, i) {
        var _selectedOptions$find;
        var isChecked = tempSelectedOptions === null || tempSelectedOptions === void 0 ? void 0 : tempSelectedOptions.some(function (item) {
          return item.id === option.id && (item === null || item === void 0 ? void 0 : item.filterField) === fieldName;
        });
        var countInSelected = selectedOptions === null || selectedOptions === void 0 ? void 0 : (_selectedOptions$find = selectedOptions.find(function (selectedOption) {
          return selectedOption.id === option.id;
        })) === null || _selectedOptions$find === void 0 ? void 0 : _selectedOptions$find.count;
        return /*#__PURE__*/React.createElement(CheckBox, {
          filterType: filterType,
          disabled: option.count == 0 && !isChecked,
          count: countInSelected || option.count,
          key: option.id,
          name: name,
          label: option.name,
          value: option.id,
          onChange: onChange,
          logo: option.icon_url,
          alt: option.altName,
          fieldName: fieldName,
          checked: isChecked,
          carshape: carshape,
          carShapeImage: option.icon_url,
          carType: option.name
          // all related to car shape checkobox
          ,
          isColorFilter: isColorFilter,
          color: option.hex_code || "",
          isColor: isColor,
          isWhite: option.id === 1 || option.id === 9 || option.id === 8,
          filter: filter,
          option: option
        });
      }));
    }
    if (searchable && (options === null || options === void 0 ? void 0 : options.length) > 0 && (filter === null || filter === void 0 ? void 0 : filter.filterField) === "model_id") {
      var _filteredOptions3;
      return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
        className: stl.textBoxContainer
      }, /*#__PURE__*/React.createElement("img", {
        src: CDN_LINK + "/assets/images/textsearch.svg",
        alt: "search"
      }), /*#__PURE__*/React.createElement("input", {
        id: "filter-checkbox-search-model",
        type: "text",
        placeholder: t("ابحث عن الماركة", {
          ns: "web_search"
        }),
        value: searchValue,
        onChange: function onChange(e) {
          return setSearchValue(e.target.value);
        }
      })), (_filteredOptions3 = filteredOptions()) === null || _filteredOptions3 === void 0 ? void 0 : _filteredOptions3.map(function (option, i) {
        var _option$values;
        var isChecked = tempSelectedOptions === null || tempSelectedOptions === void 0 ? void 0 : tempSelectedOptions.some(function (item) {
          return item.id === option.id && (item === null || item === void 0 ? void 0 : item.filterField) === fieldName;
        });
        return /*#__PURE__*/React.createElement(React.Fragment, {
          key: i + "subIndex"
        }, /*#__PURE__*/React.createElement("div", {
          className: stl.groupContainer
        }, /*#__PURE__*/React.createElement("div", {
          className: stl.subGroupHeading
        }, option.icon_url && !option.modelName && /*#__PURE__*/React.createElement("div", {
          className: stl.carLogo
        }, /*#__PURE__*/React.createElement("img", {
          src: option.icon_url,
          alt: option.altName
        })), /*#__PURE__*/React.createElement("span", {
          className: isBoldGropuTitle ? stl.isBoldGropuTitle : undefined
        }, option.name), /*#__PURE__*/React.createElement("span", {
          className: isBoldGropuTitle ? stl.isBoldGropuTitle : undefined
        }, option.modelName)), /*#__PURE__*/React.createElement("div", {
          className: stl.makesContainer
        }, (_option$values = option.values) === null || _option$values === void 0 ? void 0 : _option$values.map(function (subOpt, idx) {
          var _selectedOptions$find2;
          var isChecked = tempSelectedOptions === null || tempSelectedOptions === void 0 ? void 0 : tempSelectedOptions.some(function (item) {
            return item.id === subOpt.id && (item === null || item === void 0 ? void 0 : item.filterField) === fieldName;
          });
          var countInSelected = selectedOptions === null || selectedOptions === void 0 ? void 0 : (_selectedOptions$find2 = selectedOptions.find(function (selectedOption) {
            return selectedOption.id === subOpt.id;
          })) === null || _selectedOptions$find2 === void 0 ? void 0 : _selectedOptions$find2.count;
          return /*#__PURE__*/React.createElement(CheckBox, {
            filterType: filterType,
            disabled: subOpt.count == 0 && !isChecked ? true : false,
            modelId: option.modelId,
            makeId: option.id,
            fieldName: fieldName,
            key: idx + "carSubModel",
            name: name,
            count: countInSelected || subOpt.count,
            option: subOpt,
            label: subOpt.name,
            value: subOpt.id,
            onChange: onChange,
            checked: isChecked,
            filter: filter
          });
        }))));
      }));
    }
    return options === null || options === void 0 ? void 0 : options.map(function (option, i) {
      var _selectedOptions$find3;
      var isChecked = tempSelectedOptions === null || tempSelectedOptions === void 0 ? void 0 : tempSelectedOptions.some(function (item) {
        return item.id === option.id && (item === null || item === void 0 ? void 0 : item.filterField) === fieldName;
      });
      var countInSelected = selectedOptions === null || selectedOptions === void 0 ? void 0 : (_selectedOptions$find3 = selectedOptions.find(function (selectedOption) {
        return selectedOption.id === option.id;
      })) === null || _selectedOptions$find3 === void 0 ? void 0 : _selectedOptions$find3.count;
      if (hasSubGroups) {
        var _option$values2;
        return /*#__PURE__*/React.createElement(React.Fragment, {
          key: i + "subIndex"
        }, /*#__PURE__*/React.createElement("div", {
          className: stl.groupContainer
        }, /*#__PURE__*/React.createElement("div", {
          className: stl.subGroupHeading
        }, option.icon_url && !option.modelName && /*#__PURE__*/React.createElement("div", {
          className: stl.carLogo
        }, /*#__PURE__*/React.createElement("img", {
          src: option.icon_url,
          alt: option.altName
        })), /*#__PURE__*/React.createElement("span", {
          className: isBoldGropuTitle ? stl.isBoldGropuTitle : undefined
        }, option.name), /*#__PURE__*/React.createElement("span", {
          className: isBoldGropuTitle ? stl.isBoldGropuTitle : undefined
        }, option.modelName)), /*#__PURE__*/React.createElement("div", {
          className: stl.makesContainer
        }, (_option$values2 = option.values) === null || _option$values2 === void 0 ? void 0 : _option$values2.map(function (subOpt, idx) {
          var _selectedOptions$find4;
          var isChecked = tempSelectedOptions === null || tempSelectedOptions === void 0 ? void 0 : tempSelectedOptions.some(function (item) {
            return item.id === subOpt.id && (item === null || item === void 0 ? void 0 : item.filterField) === fieldName;
          });
          var countInSelected = selectedOptions === null || selectedOptions === void 0 ? void 0 : (_selectedOptions$find4 = selectedOptions.find(function (selectedOption) {
            return selectedOption.id === subOpt.id;
          })) === null || _selectedOptions$find4 === void 0 ? void 0 : _selectedOptions$find4.count;
          return /*#__PURE__*/React.createElement(CheckBox, {
            filterType: filterType,
            disabled: subOpt.count == 0 && !isChecked ? true : false,
            modelId: option.modelId,
            makeId: option.id,
            fieldName: fieldName,
            key: idx + "carSubModel",
            name: name,
            count: countInSelected || subOpt.count,
            option: subOpt,
            label: subOpt.name,
            value: subOpt.id,
            onChange: onChange,
            checked: isChecked,
            filter: filter
          });
        }))));
      }
      return /*#__PURE__*/React.createElement(CheckBox
      // all related to car shape checkobox
      , {
        filterType: filterType,
        disabled: false,
        fieldName: fieldName,
        carshape: carshape,
        carShapeImage: option.icon_url,
        carType: option.name
        // all related to car shape checkobox
        ,
        isColorFilter: isColorFilter,
        key: option.id,
        name: name,
        option: option,
        label: option.name,
        value: option.id,
        onChange: onChange,
        count: countInSelected || option.count,
        checked: isChecked,
        color: option.hex_code || "",
        isColor: isColor,
        isWhite: option.id === 1 || option.id === 9,
        filter: filter
      });
    });
  };
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    id: "filter-checkbox-group",
    className: [stl.container, carshape ? [stl.noPadding, stl.shapContainer].join(" ") : undefined].join(" ")
  }, renderer()), /*#__PURE__*/React.createElement("div", {
    id: "filter-checkbox-note",
    className: stl.noteContainer
  }, /*#__PURE__*/React.createElement("p", null, /*#__PURE__*/React.createElement("strong", null, t("حاول إزالة بعض الفلاتر", {
    ns: "web_search"
  })), " ", /*#__PURE__*/React.createElement("span", null, t("لإيجاد نتائج بحث مطابقة", {
    ns: "web_search"
  }))), /*#__PURE__*/React.createElement("button", {
    id: "filter-checkbox-back-btn",
    onClick: handleCloseFilter
  }, t("العودة لفلترة النتائج", {
    ns: "web_search"
  }))));
};
export default CheckBoxGroup;